
const QUERY_PARAMS = Object.freeze({
  SKELETON_UI: 'skeleton-ui'
});

const URL_PARAMS = Object.freeze({
  PATTERN_ID: 'patternId'
});

const PAGES = Object.freeze({
  HOME: '/',
  PATTERN: `/pattern/:${URL_PARAMS.PATTERN_ID}`
});

export {
  PAGES,
  URL_PARAMS,
  QUERY_PARAMS
};
